module.exports = __webpack_public_path__ + "img/bb_img1.466b3776.png";